import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-height-1",
  "use": "icon-line-height-1-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-line-height-1\"><path d=\"M4 9.5h12m-12 5h12M4 4.5h12\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol